import { render, staticRenderFns } from "./coming_soon.vue?vue&type=template&id=5a9ec7e8"
import script from "./coming_soon.vue?vue&type=script&lang=js"
export * from "./coming_soon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports